// thunks.ts
//
// (c) NCR Voyix Corporation 2025. All rights reserved.

import { createAsyncThunk } from '@reduxjs/toolkit'
import { buildAuthenticatedUser } from '../../common/authenticatedUser'
import { post } from '../../common/upgradesApiClient'
import { SaveDeploymentRequest } from '../../dtos/deployment/saveDeploymentRequest'
import { FuncResult } from '../../common/result'

export const saveDeploymentLite = createAsyncThunk(
  'deploymentLite/saveDeploymentLite',
  async (args: {
    userId: string
    sessionId: string
    datacenter: string
    companyId: string
    deployment: SaveDeploymentRequest
  }): Promise<FuncResult<void>> => {
    const {
      userId, sessionId, datacenter, companyId, deployment
    } = args
    const authenticatedUser = buildAuthenticatedUser(
      sessionId,
      datacenter,
      userId
    )

    const saveResult = await post<SaveDeploymentRequest, FuncResult<void>>(
      {
        route: 'deployment',
        body: deployment,
        user: authenticatedUser,
        optionalHeaders: {
          companyid: companyId
        }
      }
    )

    return saveResult
  }
)
